import React, { useState, useEffect } from "react";
import "./superManagerDashboard.css";
import { Layout, message, Spin } from "antd";
import Lense from "../../Images/Lense-Logo.png";
import Darts from "../../Images/Darts-Logo.png";
import Clan from "../../Images/clan_logo.png";
import Clients from "../../Images/clientsLogo.png";
import Roles from "../../Images/rolesLogo.png";
import Users from "../../Images/usersLogo.png";
import SyncLogo from "../../Images/Sync_Logo 2.png";
import { Accounts_Query, Dashboard_API, GET_USERS_ASSIGNED_TO_ACCOUNT, Role_Account_Query } from "../../services/userAPI";
import { useLazyQuery, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import LoadingImage from "../../Images/icon2.png";
import SearchableDropdown from "../../reusableField/searchableDropdownField";
import Editicon from "../../Images/Edit.png";
import MoreClientsImage from "../../Images/more-clients-logo.png";
import LenseLogo from "../../Images/lense-logo-red-color.png";
import DartsLogo from "../../Images/darts-logo-red-color.png";
import ClanLogo from "../../Images/clan-logo-red-color.png";
import Sync from "../../Images/Syncblack_Logo 2.png"

const { Content } = Layout;

const SuperManagerDashboard = () => {
    const { loading, error, data } = useQuery(Dashboard_API);
    const navigate = useNavigate();
    const [selectedRoles, setSelectedRoles] = useState({});
    const [selectedValues, setSelectedValues] = useState({});
    const [loadingRoles, setLoadingRoles] = useState({});
    const [imageError, setImageError] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const [hoverIndex, setHoverIndex] = useState(null);

    const { loading: accountsLoading, error: accountsError, data: accountsData } = useQuery(Accounts_Query);

    const statsData = {
        clients: data?.getDashboardValues?.totalClients,
        roles: data?.getDashboardValues?.totalRoles,
        users: data?.getDashboardValues?.totalUsers,
    };

    const [fetchRoles] = useLazyQuery(Role_Account_Query, {
        fetchPolicy: 'network-only',
        onCompleted: (data, context) => {
            // Try to get accountId from multiple sources
            const roles = data?.getAllJobrole || [];
            let accountId = roles[0]?.account?.id;

            // If empty array, try to get from context
            if (!accountId && context?.variables) {
                accountId = context.variables.accountId;
            }

            console.log("Roles fetched:", { accountId, rolesCount: roles.length, data });

            if (accountId) {
                setSelectedRoles((prevRoles) => ({
                    ...prevRoles,
                    [accountId]: roles,
                }));
                setLoadingRoles((prev) => ({
                    ...prev,
                    [accountId]: false,
                }));
            }
        },
        onError: (error, context) => {
            console.error("Error fetching roles:", error);
            const accountId = context?.variables?.accountId || error.extraInfo?.variables?.accountId;
            if (accountId) {
                setSelectedRoles((prevRoles) => ({
                    ...prevRoles,
                    [accountId]: [],
                }));
                setLoadingRoles((prev) => ({
                    ...prev,
                    [accountId]: false,
                }));
            }
        },
    });

    const [fetchAssignedUsers] = useLazyQuery(GET_USERS_ASSIGNED_TO_ACCOUNT);


    const handleImageError = (userId) => {
        setImageError((prev) => ({
            ...prev,
            [userId]: true,
        }));
    };

    const handleAccountChange = (accountId) => {
        if (!selectedRoles.hasOwnProperty(accountId)) {
            console.log("Fetching roles for accountId:", accountId);
            setLoadingRoles((prev) => ({
                ...prev,
                [accountId]: true,
            }));

            fetchRoles({
                variables: { accountId: parseInt(accountId) },
            }).then((result) => {
                // Fallback: if onCompleted didn't handle it
                const roles = result?.data?.getAllJobrole || [];
                console.log("Fetch completed with roles:", roles.length);

                if (roles.length === 0 && !selectedRoles.hasOwnProperty(accountId)) {
                    setSelectedRoles((prevRoles) => ({
                        ...prevRoles,
                        [accountId]: [],
                    }));
                    setLoadingRoles((prev) => ({
                        ...prev,
                        [accountId]: false,
                    }));
                }
            }).catch((error) => {
                console.error("Fetch error:", error);
                setLoadingRoles((prev) => ({
                    ...prev,
                    [accountId]: false,
                }));
            });
        }
    };

    const handleRoleChange = (value, accountId) => {
        setSelectedValues((prev) => ({
            ...prev,
            [accountId]: value,
        }));
    };

    const handleEdit = async (accountId, userData) => {
        try {
            const { data, error } = await fetchAssignedUsers({
                variables: { accountId: parseInt(accountId) },
            });

            if (error) {
                console.error("Error fetching assigned users:", error);
                message.error("Failed to fetch assigned users.");
                return;
            }

            const assignedUsers = data?.getUsersAssignedToAccount || [];
            const assignedAdminIds = assignedUsers.map(user => user.id);
            const selectedRole = selectedValues[accountId];
            let cleanedColor = userData.brandColor;
            if (cleanedColor.toLowerCase().startsWith("ff")) {
                cleanedColor = cleanedColor.slice(2);
            }
            navigate(`/create?accountId=${accountId}&roleId=${selectedRole}`, {
                state: {
                    id: userData.id,
                    name: userData.name,
                    url: userData.url,
                    address: userData.address,
                    address2: userData.address2,
                    brandColor: cleanedColor,
                    lenseNeeded: userData.lenseNeeded,
                    dartsNeeded: userData.dartsNeeded,
                    clanNeeded: userData.clanNeeded,
                    syncNeeded: userData.syncNeeded,
                    emailLogin: userData.emailLogin,
                    numberLogin: userData.numberLogin,
                    imageUrl: userData.imageUrl,
                    mainLogoUrl: userData.mainLogoUrl,
                    selfRegistration: userData.selfRegistration,
                    assignedAdmin: assignedAdminIds, // Pass numeric IDs
                    assignedAdminUsers: assignedUsers,
                    signInSignOutRequired: userData.signInSignOutRequired,
                    locationRequired: userData.locationRequired,
                    ldmsNeeded: userData.ldmsNeeded,
                    mirrorNeeded: userData.mirrorNeeded,
                    geoTracking: userData.geoTracking,


                },
            });
        } catch (err) {
            console.error("Error in handleEdit:", err);
            message.error('An unexpected error occurred while trying to edit the account.');
        }
    };

    if (accountsLoading)
        return (
            <div className="loading-container">
                <div className="spinner"></div>
            </div>
        );

    if (accountsError) return <div>Error: {accountsError.message}</div>;

    const filteredAccounts = accountsData?.allUserAccount?.filter((user) =>
        user.name.toLowerCase().includes(searchQuery.toLowerCase()))
        ?.reverse();

    const overviewData = [
        { name: "LENSE", image: Lense, hoverImage: LenseLogo, totalUsers: data?.getDashboardValues?.totalLenseUsers },
        { name: "DARTS", image: Darts, hoverImage: DartsLogo, totalUsers: data?.getDashboardValues?.totalDartsUsers },
        { name: "CLAN", image: Clan, hoverImage: ClanLogo, totalUsers: data?.getDashboardValues?.totalClanUsers },
        { name: "SYNC", image: Sync, hoverImage: SyncLogo, totalUsers: data?.getDashboardValues?.totalsyncredUsers },];

    return (
        <Content>
            <div className="dashboard-container">
                <div>
                    <h2 className="dashboardHeading">Dashboard</h2>
                </div>
                <div className="dashboard-content">
                    <div className="stats-container" >
                        <div className="stats-left">
                            <div className="stats-item-client">
                                <div className="stats-icon">
                                    <img className="super-manager-image-client" src={Clients} alt="Clients" />
                                </div>
                                <div className="stats-content">
                                    <span className="stats-client">{statsData.clients === 1 ? "Client" : "Clients"}</span>
                                    <span className="stats-value-client">{statsData.clients}</span>
                                </div>
                            </div>

                            <div className="stats-item">
                                <div className="stats-icon">
                                    <img className="super-manager-image" src={Roles} alt="Roles" />
                                </div>
                                <div className="stats-content">
                                    <span className="stats-label">{statsData.roles === 1 ? "Role" : "Roles"}</span>
                                    <span className="stats-value">{statsData.roles}</span>
                                </div>
                            </div>

                            <div className="stats-item">
                                <div className="stats-icon">
                                    <img className="super-manager-image" src={Users} alt="Users" />
                                </div>
                                <div className="stats-content">
                                    <span className="stats-label">{statsData.users === 1 ? "Product User" : "Product Users"}</span>
                                    <span className="stats-value">{statsData.users}</span>
                                </div>
                            </div>


                        </div>
                        <div className="stats-right">
                            {overviewData.map((item, index) => (
                                <div
                                    className={`product-card-dashboard ${hoverIndex === index ? "hovered" : ""}`}
                                    key={index}
                                    onMouseEnter={() => setHoverIndex(index)}
                                    onMouseLeave={() => setHoverIndex(null)}
                                >
                                    <div className="product-logo-super-manager">
                                        <img src={hoverIndex === index && item.hoverImage ? item.hoverImage : item.image} alt={item.name} />
                                    </div>
                                    <div className="product-stats">
                                        <span className="product-label">Total Users</span>
                                        <span className="product-value">{item.totalUsers || 0}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <br />
                    <div>
                        <h2 className="dashboardHeading">Clients</h2>
                    </div>
                    <Content>
                        <div className="cards-container-dashboard">
                            {filteredAccounts?.slice(0, 4).map((user) => {
                                const isRoleSelected = Boolean(selectedValues[user.id]);
                                const hasNoRoles = user.numberOfRoles === 0;
                                return (
                                    <div key={user.id} className="card">
                                        <div className="card-header">
                                            {imageError[user.id] || !user.mainLogoUrl ? (
                                                <div className="placeholderImage">
                                                    <span className="placeholder-text">No Image</span>
                                                </div>
                                            ) : (
                                                <img
                                                    src={user.mainLogoUrl}
                                                    alt={user.name}
                                                    className="card-image"
                                                    onError={() => handleImageError(user.id)} // Handle error
                                                />
                                            )}
                                            <img
                                                src={Editicon}
                                                alt="Edit"
                                                className="edit-icon"
                                                onClick={() => handleEdit(user.id, user)} // Edit button triggers handleEdit
                                            />
                                        </div>
                                        <h3 className="card-title">{user.name}</h3>
                                        <div className="card-actions">
                                            <SearchableDropdown
                                                options={selectedRoles[user.id] || []}
                                                label="name"
                                                id="id"
                                                selectedVal={selectedValues[user.id]}
                                                handleChange={(value) => handleRoleChange(value, user.id)}
                                                placeholder={
                                                    hasNoRoles && !loadingRoles[user.id]
                                                        ? "No roles found"
                                                        : loadingRoles[user.id]
                                                            ? "Loading roles..."
                                                            : "Select Role"
                                                }
                                                onFocus={() => handleAccountChange(user.id)}
                                                disabled={false}
                                                loading={loadingRoles[user.id]}
                                                notFoundContent={
                                                    hasNoRoles && !loadingRoles[user.id] ? "No roles found" : loadingRoles[user.id] ? <Spin size="small" /> : null
                                                }
                                            />
                                            <button
                                                className={`view-role-button`}
                                                onClick={() => {
                                                    const selectedRoleId = selectedValues[user.id];
                                                    if (selectedRoleId) {
                                                        const selectedRoleData = selectedRoles[user.id]?.find(
                                                            (role) => role.id === selectedRoleId
                                                        );
                                                        if (selectedRoleData) {
                                                            navigate("/experience-configuration", {
                                                                state: {
                                                                    roleId: selectedRoleId,
                                                                    dartsNeeded: selectedRoleData.dartsNeeded,
                                                                    clanNeeded: selectedRoleData.clanNeeded,
                                                                    syncNeeded: selectedRoleData.syncNeeded,
                                                                    lenseNeeded: selectedRoleData.lenseNeeded || false,
                                                                    emailLogin: selectedRoleData.emailLogin,
                                                                    inputEditDays: selectedRoleData.inputEditDays,
                                                                    mandatoryTimeDistribution: selectedRoleData.mandatoryTimeDistribution,
                                                                    numberLogin: selectedRoleData.numberLogin,
                                                                    name: selectedRoleData.name,
                                                                    pocEmail: selectedRoleData.pocEmail || "",
                                                                    pocName: selectedRoleData.pocName || "",
                                                                    pocNumber: selectedRoleData.pocContactNumber || "",
                                                                    targetEditDays: selectedRoleData.targetEditDays,
                                                                    dartsFormNeeded: selectedRoleData.dartsFormNeeded,
                                                                    accountId: selectedRoleData.account.id,
                                                                    accountName: selectedRoleData.account?.name || "unknown",
                                                                },
                                                            });
                                                        }
                                                    }
                                                }}
                                                disabled={!selectedValues[user.id] || hasNoRoles}
                                                style={{
                                                    backgroundColor: selectedValues[user.id]
                                                        ? "#AD0101"
                                                        : hasNoRoles
                                                            ? "#dcdcdc"
                                                            : "#FAC9CA",
                                                    cursor: selectedValues[user.id]
                                                        ? "pointer"
                                                        : "not-allowed",
                                                }}
                                            >
                                                View Role
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        {filteredAccounts?.length > 3 && (
                            <div className="more-clients-container">
                                <button className="more-clients-btn" onClick={() => navigate("/admin")}>
                                    More Clients
                                </button>
                            </div>
                        )}
                    </Content>
                </div >
            </div>

        </Content >
    );
};

export default SuperManagerDashboard;